/* eslint-disable @typescript-eslint/no-unnecessary-condition */
import { pathFinder } from '../path-finder';
import { Direction, PathFinderParams } from '../types';
import {
    checkInBetweenNodesInXDirection,
    checkInBetweenNodesInYDirection,
    getDirection,
    getNodesList,
    moveDown,
    moveHorizontal
} from '../utils';

export const loopbackFinder = ({ source, target, stations, pathNodeList }: PathFinderParams) => {
    const stationNodeList = getNodesList(stations);
    const direction: Direction = getDirection({ source, target });
    const xDirection = direction.x || 1;

    // Add one step down and then left or right if the path is loop back
    const path = [source];
    let point = moveDown(source);
    path.push(point);
    // Move right or left until there are no stations in between
    do {
        // Check if in the opposite direction there are stations in between
        const horizontalDirection = checkInBetweenNodesInXDirection({
            source,
            target: { ...target, x: -xDirection === -1 ? 0 : Number.MAX_SAFE_INTEGER },
            direction: { ...direction, x: -xDirection },
            nodeList: stationNodeList
        })
            ? xDirection
            : -xDirection;
        point = moveHorizontal(point, horizontalDirection);
        path.push(point);
    } while (
        checkInBetweenNodesInYDirection({ source: point, target, direction, nodeList: stationNodeList }) ||
        checkInBetweenNodesInYDirection({ source: point, target, direction, nodeList: pathNodeList, count: 2 })
    );

    path.push(
        ...pathFinder({
            source: point,
            target,
            stations,
            pathNodeList,
            isLoopBackPath: true
        }).slice(1)
    );

    return path;
};
